import Vue from 'vue/dist/vue.js';
import VueRouter from 'vue-router'
import VueSimpleMarkdown from 'vue-simple-markdown'

// 静态资源导入
import statpointLogo from './assets/icon_statpoint_logo.png'
import i18n from './i18n'
import { applyPageTitle } from './utils/page-title'

import VueLoading from 'vue-loading-template'
import analyticsManager from '@/services/analytics_manager.js'

// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'vue-simple-markdown/dist/vue-simple-markdown.css'
import './assets/tailwind.css'
import './assets/basboard-brand.css'
import './assets/brand-motion.css'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueSimpleMarkdown)
Vue.use(VueLoading)

// 使用动态导入实现路由懒加载
// webpackChunkName 注释用于指定生成的 chunk 文件名
const routes = [
  { name: 'support', path: '/support', component: () => import(/* webpackChunkName: "basboard-support" */ './pages/support/Support.vue') },
  { name: 'index', path: '/', component: () => import(/* webpackChunkName: "basboard-preview-index" */ './pages/index/PreviewIndex.vue') },
  { name: 'previewIndex', path: '/preview', redirect: '/' },
  { name: 'tacticDetail', path: '/tactic/:id', component: () => import(/* webpackChunkName: "basboard-preview" */ './pages/preview/Preview.vue') },
  { name: 'collectionDetail', path: '/collection/:id', component: () => import(/* webpackChunkName: "basboard-collection-preview" */ './pages/collection/CollectionPreview.vue') },
  { name: 'privacy', path: '/privacy', component: () => import(/* webpackChunkName: "basboard-privacy" */ './pages/privacy/Privacy.vue') },
  { name: 'agreement', path: '/agreement', component: () => import(/* webpackChunkName: "basboard-agreement" */ './pages/agreement/Agreement.vue') },
  { name: 'memberAgreement', path: '/memberAgreement', component: () => import(/* webpackChunkName: "basboard-member-agreement" */ './pages/member_agreement/MemberAgreement.vue') },
  { name: 'PrivacySDKList', path: '/privacySDKList', component: () => import(/* webpackChunkName: "basboard-privacy-sdk" */ './pages/privacy_sdk_list/PrivacySDKList.vue') },

  { name: 'basketballLib', path: '/library/basketball', component: () => import(/* webpackChunkName: "library-basketball" */ './pages/library/basketball/BaseketballLibrary.vue') },

  { name: 'traincordIndex', path: '/traincord/index', component: () => import(/* webpackChunkName: "traincord-index" */ './pages/traincord/index/Index.vue') },
  { name: 'traincordAgreement', path: '/traincord/agreement', component: () => import(/* webpackChunkName: "traincord-agreement" */ './pages/traincord/agreement/Agreement.vue') },
  { name: 'traincordPrivacy', path: '/traincord/privacy', component: () => import(/* webpackChunkName: "traincord-privacy" */ './pages/traincord/privacy/Privacy.vue') },

  { name: 'statpointIndex', path: '/statpoint', component: () => import(/* webpackChunkName: "statpoint-index" */ './pages/statpoint/index/Index.vue') },
  { name: 'statpointAgreement', path: '/statpoint/agreement', component: () => import(/* webpackChunkName: "statpoint-agreement" */ './pages/statpoint/agreement/Agreement.vue') },
  { name: 'statpointPrivacy', path: '/statpoint/privacy', component: () => import(/* webpackChunkName: "statpoint-privacy" */ './pages/statpoint/privacy/Privacy.vue') },
  { path: '/statpoint/*', redirect: '/statpoint' },

  { name: 'faqList', path: '/faq', component: () => import(/* webpackChunkName: "faq-list" */ './pages/faq/FaqList.vue'), meta: { title: '帮助中心' } },
  { name: 'faqDetail', path: '/faq/:id', component: () => import(/* webpackChunkName: "faq-detail" */ './pages/faq/FaqDetail.vue'), meta: { title: '详情' } },

  { name: '404', path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  let isStatPointPage = to.path.includes("statpoint")

  // Update Favicon
  const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';

  if (isStatPointPage) {
    link.href = statpointLogo;
  } else {
    link.href = '/favicon.ico';
  }
  document.getElementsByTagName('head')[0].appendChild(link);

  applyPageTitle(to, i18n.locale)
  next()
})

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    analyticsManager.trackPageView(to, from)
  })
})

new Vue({
  router,
  i18n
}).$mount('#app')
